<script lang="ts">
    import type {User} from 'src/typings';
    import KpUserInfoCard from '../../../../../../features/user/KpUserInfoCard.svelte';

    export let value: User;
    export let isSelected = false;
</script>

<div class="panel panel-default" class:panel-primary={isSelected}>
    <div class="panel-body">
        <KpUserInfoCard user={value}/>
    </div>
</div>